import React from 'react';
import { Helmet } from 'react-helmet';
import teacherImage from '../assets/images/teachers/mohamedsaid.png';

const About: React.FC = () => {
  return (
    <>
      <Helmet>
        {/* Primary Meta Tags */}
        <title>عن مستر وليد المصري - مدرس اللغة الإنجليزية للمرحلة الثانوية | منصة مستر وليد المصري</title>
        <meta name="title" content="عن مستر وليد المصري - مدرس اللغة الإنجليزية للمرحلة الثانوية | منصة مستر وليد المصري" />
        <meta name="description" content="تعرف على مستر وليد المصري — مدرس اللغة الإنجليزية للمرحلة الثانوية. منصة تعليمية لطلاب أولى وثانية وثالثة ثانوي مع شرح متدرج للكلمات والقواعد والقراءة والكتابة." />
        <meta name="keywords" content="مستر وليد المصري, وليد المصري, مدرس انجليزي ثانوي, سيرة ذاتية, تعليم اللغة الإنجليزية, منصة تعليمية, ثانوية عامة" />
        <meta name="author" content="مستر وليد المصري" />
        <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
        
        {/* Canonical URL */}
        <link rel="canonical" href="https://mohamed-said.com/about" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="profile" />
        <meta property="og:url" content="https://mohamed-said.com/about" />
        <meta property="og:title" content="عن مستر وليد المصري - مدرس اللغة الإنجليزية للمرحلة الثانوية" />
        <meta property="og:description" content="تعرف على مستر وليد المصري — مدرس اللغة الإنجليزية للمرحلة الثانوية ومنصة تعليمية متكاملة لطلاب الثانوية العامة." />
        <meta property="og:image" content="https://mohamed-said.com/favicon.png" />
        <meta property="og:image:width" content="512" />
        <meta property="og:image:height" content="512" />
        <meta property="og:image:alt" content="مستر وليد المصري - مدرس اللغة الإنجليزية للمرحلة الثانوية" />
        <meta property="og:site_name" content="منصة مستر وليد المصري التعليمية" />
        <meta property="og:locale" content="ar_AR" />

        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://mohamed-said.com/about" />
        <meta property="twitter:title" content="عن مستر وليد المصري - مدرس اللغة الإنجليزية للمرحلة الثانوية" />
        <meta property="twitter:description" content="تعرف على مستر وليد المصري — مدرس اللغة الإنجليزية للمرحلة الثانوية." />
        <meta property="twitter:image" content="https://mohamed-said.com/favicon.png" />
        <meta property="twitter:creator" content="@mohamed_said" />

        {/* Additional SEO Meta Tags */}
        <meta name="language" content="Arabic" />
        <meta name="geo.region" content="EG" />
        <meta name="subject" content="سيرة مدرس اللغة الإنجليزية" />
        <meta name="category" content="تعليم" />
        <meta name="classification" content="منصة تعليمية" />

        {/* Structured Data for Person */}
        <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Person",
          "name": "مستر وليد المصري",
          "alternateName": ["وليد المصري", "Walid El-Masry", "مستر وليد"],
          "jobTitle": "مدرس اللغة الإنجليزية للمرحلة الثانوية",
          "description": "مدرس لغة إنجليزية للمرحلة الثانوية — شرح وتدريب لأولى وثانية وثالثة ثانوي",
          "url": "https://mohamed-said.com/about",
          "image": "https://mohamed-said.com/favicon.png",
          "sameAs": [
            "https://www.facebook.com/mohamed.said",
            "https://www.youtube.com/@mohamedsaid",
            "https://www.instagram.com/mohamed_said"
          ],
          "knowsAbout": [
            "اللغة الإنجليزية",
            "English Grammar", 
            "English Conversation",
            "IELTS",
            "تعليم الإنجليزية",
            "المناهج الدراسية",
            "التحضير للامتحانات",
            "الدروس الخصوصية"
          ],
          "hasOccupation": {
            "@type": "Occupation",
            "name": "مدرس خصوصي",
            "occupationLocation": {
              "@type": "Place",
              "name": "مصر"
            }
          },
          "address": {
            "@type": "PostalAddress",
            "addressCountry": "EG",
            "addressRegion": "القاهرة"
          },
          "telephone": "+20-100-000-0000",
          "email": "mohamed@mohamed-said.com"
        })}
        </script>
      </Helmet>
      
      <div className="min-h-screen bg-gray-50" dir="rtl">
      <div className="max-w-7xl mx-auto">
        <div className="min-h-screen flex flex-col lg:flex-row">
          {/* Left Side - Photo */}
          <div className="lg:w-[45%] bg-white relative">
            <div className="sticky top-0 h-screen flex items-center justify-center p-8">
              <div className="relative group">
                <div className="absolute inset-0 bg-gradient-to-r from-blue-600/20 to-blue-800/20 rounded-3xl blur-2xl group-hover:blur-3xl transition-all duration-500"></div>
                <div className="relative">
                  <img
                    src={teacherImage}
                    alt="مستر وليد المصري - مدرس اللغة الإنجليزية للمرحلة الثانوية"
                    className="w-full h-auto max-w-lg rounded-3xl shadow-2xl transform group-hover:scale-[1.02] transition-transform duration-500"
                  />
                  <div className="absolute -bottom-6 right-8 left-8 bg-white/80 backdrop-blur-sm rounded-2xl p-6 shadow-lg">
                    <h1 className="text-3xl font-bold text-gray-900 mb-1 font-arabic text-center">
                      مستر وليد المصري
                    </h1>
                    <div className="flex justify-center">
                      <span className="text-lg text-blue-600 font-medium font-arabic">مدرس اللغة الإنجليزية — المرحلة الثانوية</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side - Content */}
          <div className="lg:w-[55%] bg-white p-8 lg:p-16">
            {/* Title Badge */}
            <div className="inline-flex items-center bg-blue-50 rounded-full px-6 py-2 mb-12">
              <span className="w-2 h-2 bg-blue-600 rounded-full ml-3"></span>
              <span className="text-blue-800 font-semibold">مدرس اللغة الإنجليزية للمرحلة الثانوية</span>
            </div>

            {/* About Section */}
            <div className="prose prose-lg max-w-none mb-12">
              <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 border border-gray-100">
                <p className="text-xl leading-relaxed text-gray-700 mb-6 font-arabic">
                  مستر وليد المصري — مدرس لغة إنجليزية للمرحلة الثانوية، يقدّم شروحات مناسبة لطلاب أولى وثانية وثالثة ثانوي مع التركيز على الكلمات والقواعد والقراءة والكتابة.
                </p>
                <p className="text-lg text-gray-600 font-arabic mb-4">
                  هدف المنصة تبسيط منهج اللغة الإنجليزية للثانوية العامة وجعل التعلم ممتعاً وفعّالاً، مع متابعة ودعم للوصول لأفضل النتائج.
                </p>
                <p className="text-lg text-gray-600 font-arabic">
                  شعارنا: العلامة الكاملة مضمونة — مع تدريب مستمر على امتحانات وأسلوب يصلح لكل المستويات.
                </p>
              </div>
            </div>

            {/* Qualifications */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 font-arabic flex items-center">
                <span className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center ml-3">
                  <span className="text-blue-600">✓</span>
                </span>
                المؤهلات والدورات
              </h2>
              <div className="grid gap-4">
                {[
                  'تدريس منهج اللغة الإنجليزية للمرحلة الثانوية (أولى — ثانية — ثالثة)',
                  'تدريب على القواعد والمفردات والقراءة والكتابة والاستماع',
                  'مراجعات وامتحانات تجهزك لنمط الأسئلة في المدرسة والامتحان',
                  'شرح يناسب مختلف المستويات مع متابعة للطالب',
                  'منصة أونلاين مع دعم وتواصل مع الطلاب',
                  'التركيز على الوصول للعلامة الكاملة والثقة في المادة'
                ].map((cert, index) => (
                  <div 
                    key={index} 
                    className="flex items-center bg-gray-50 hover:bg-gray-100 p-4 rounded-xl transition-colors"
                  >
                    <span className="w-10 h-10 bg-blue-600/10 rounded-lg flex items-center justify-center ml-4 text-blue-600 font-bold">
                      {index + 1}
                    </span>
                    <span className="text-gray-700">{cert}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Teaching Features */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 font-arabic flex items-center">
                <span className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center ml-3">
                  <span className="text-blue-600">★</span>
                </span>
                ما يميز أسلوب التدريس
              </h2>
              <div className="grid gap-4">
                {[
                  'تبسيط قواعد اللغة الإنجليزية والمفردات',
                  'تمارين على القراءة والكتابة والاستماع',
                  'مراجعة دورية وامتحانات أسبوعية وشهرية',
                  'شرح مناسب لأولى وثانية وثالثة ثانوي',
                  'استخدام وسائل تعليمية حديثة أونلاين',
                  'متابعة مستمرة لتقدم الطالب'
                ].map((feature, index) => (
                  <div 
                    key={index} 
                    className="group flex items-center bg-gray-50 hover:bg-gray-100 p-4 rounded-xl transition-colors"
                  >
                    <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-blue-700 rounded-lg flex items-center justify-center ml-4 group-hover:scale-110 transition-transform">
                      <span className="text-white">{'٠' + (index + 1)}</span>
                    </div>
                    <span className="text-gray-700">{feature}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Subjects Taught */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 font-arabic flex items-center">
                <span className="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center ml-3">
                  <span className="text-green-600">📚</span>
                </span>
                المواد الدراسية
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {[
                  { subject: 'اللغة الإنجليزية', level: 'المرحلة الثانوية' },
                  { subject: 'قواعد اللغة الإنجليزية', level: 'الثانوية العامة' },
                  { subject: 'المحادثة الإنجليزية', level: 'الثانوية العامة' },
                  { subject: 'الكتابة الإنجليزية', level: 'المرحلة الثانوية' },
                  { subject: 'القراءة الإنجليزية', level: 'المرحلة الثانوية' },
                  { subject: 'الاستماع الإنجليزي', level: 'الثانوية العامة' }
                ].map((item, index) => (
                  <div 
                    key={index} 
                    className="bg-gradient-to-r from-green-50 to-blue-50 p-4 rounded-xl border border-green-200"
                  >
                    <h3 className="font-bold text-gray-800 mb-1">{item.subject}</h3>
                    <p className="text-sm text-gray-600">{item.level}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Statistics */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 font-arabic flex items-center">
                <span className="w-8 h-8 bg-purple-100 rounded-lg flex items-center justify-center ml-3">
                  <span className="text-purple-600">📊</span>
                </span>
                إحصائيات التدريس
              </h2>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                {[
                  { number: '10+', label: 'سنوات خبرة' },
                  { number: '500+', label: 'طالب نجحوا' },
                  { number: '1000+', label: 'درس تم تقديمه' },
                  { number: '95%', label: 'معدل نجاح الطلاب' }
                ].map((stat, index) => (
                  <div 
                    key={index} 
                    className="text-center bg-gradient-to-br from-purple-50 to-blue-50 p-4 rounded-xl"
                  >
                    <div className="text-2xl font-bold text-purple-600 mb-1">{stat.number}</div>
                    <div className="text-sm text-gray-600">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>

            {/* CTA Button */}
            <div className="relative group inline-block">
              <div className="absolute -inset-1 bg-gradient-to-r from-blue-600 to-blue-800 rounded-lg blur opacity-25 group-hover:opacity-75 transition duration-200"></div>
              <button className="relative px-8 py-4 bg-blue-600 text-white rounded-lg font-bold hover:bg-blue-700 transition-colors">
                ابدأ رحلة التفوق مع منصة مستر وليد المصري
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default About; 